import { post } from '../common/index'

const passwordLogin = post('/blog/user/denglu')
// 网站访问

const web_visit = post('/blog/web/visit')

// 报审材料
const materials_add = post('/blog/application_materials/add')
const materials_query = post('blog/application_materials/query')
const materials_edit = post('/blog/application_materials/edit')
// 审查时限
const review_add = post('/blog/review_time/add')
const review_query = post('/blog/review_time/query')
const review_edit = post('/blog/review_time/edit')
// 收费标准
const standard_add = post('/blog/charging_standard/add')
const standard_query = post('/blog/charging_standard/query')
const standard_edit = post('/blog/charging_standard/edit')
// 企业简介
const profile_add = post('/blog/company_profile/add')
const profile_query = post('/blog/company_profile/query')
const profile_edit = post('/blog/company_profile/edit')
// 企业荣誉
const honor_add = post('/blog/enterprise_honor/add')
const honor_query = post('/blog/enterprise_honor/query')
const honor_edit = post('/blog/enterprise_honor/edit')
// 回复指南 
const guide_add = post('/blog/reply_guide/add')
const guide_query = post('/blog/reply_guide/query')
const guide_edit = post('/blog/reply_guide/edit')
const guide_queryId = post('/blog/reply_guide/queryId')
const guide_del = post('/blog/reply_guide/del')
// 友情提示
const tips_add = post('/blog/friendly_tips/add')
const tips_query = post('/blog/friendly_tips/query')
const tips_edit = post('/blog/friendly_tips/edit')
const tips_queryId = post('/blog/friendly_tips/queryId')
const tips_del = post('/blog/friendly_tips/del')
// 通知中心 
const notification_add = post('/blog/notification/add')
const notification_query = post('/blog/notification/query')
const notification_edit = post('/blog/notification/edit')
const notification_queryId = post('/blog/notification/queryId')
const notification_del = post('/blog/notification/del')
// 交流园地
const exchange_add = post('/blog/exchange_field/add')
const exchange_query = post('/blog/exchange_field/query')
const exchange_edit = post('/blog/exchange_field/edit')
const exchange_queryId = post('/blog/exchange_field/queryId')
const exchange_del = post('/blog/exchange_field/del')
// 审查成果
const current_add = post('/blog/review_results/add')
const current_query = post('/blog/review_results/query')
const current_edit = post('/blog/review_results/edit')
const current_queryId = post('/blog/review_results/queryId')
const current_del = post('/blog/review_results/del')
// 政策法规
const regulations_add = post('/blog/policies_regulations/add')
const regulations_query = post('/blog/policies_regulations/query')
const regulations_edit = post('/blog/policies_regulations/edit')
const regulations_queryId = post('/blog/policies_regulations/queryId')
const regulations_del = post('/blog/policies_regulations/del')
// 审查专家
const experts_add = post('/blog/review_experts/add')
const experts_query = post('/blog/review_experts/query')
const experts_edit = post('/blog/review_experts/edit')
const experts_queryId = post('/blog/review_experts/queryId')
const experts_del = post('/blog/review_experts/del')

export {
  web_visit,
  passwordLogin,
  materials_add,
  materials_query,
  materials_edit,
  standard_add,
  standard_query,
  standard_edit,
  review_add,
  review_query,
  review_edit,
  profile_add,
  profile_query,
  profile_edit,
  honor_add,
  honor_query,
  honor_edit,
  guide_add,
  guide_query,
  guide_edit,
  guide_queryId,
  guide_del,
  tips_add,
  tips_query,
  tips_edit,
  tips_queryId,
  tips_del,
  notification_add,
  notification_query,
  notification_edit,
  notification_queryId,
  notification_del,
  exchange_add,
  exchange_query,
  exchange_edit,
  exchange_queryId,
  exchange_del,
  current_add,
  current_query,
  current_edit,
  current_queryId,
  current_del,
  regulations_add,
  regulations_query,
  regulations_edit,
  regulations_queryId,
  regulations_del,
  experts_add,
  experts_query,
  experts_edit,
  experts_queryId,
  experts_del,
}
